import { dimensionality } from "../components/dimensionality";

export const cardDimensionality = () => dimensionality(240, 160);
